import Vue from 'vue'
import Vuesax from 'vuesax'
import axios from 'axios'
import Embed from 'v-video-embed'
import VueCollapse from 'vue2-collapse'
import App from './App.vue'
import moment from 'moment'

import VTooltip from 'v-tooltip'

import {
    BootstrapVue,
    IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'vuesax/dist/vuesax.css' //Vuesax styles
import 'material-icons/iconfont/material-icons.css';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
// Datetime
import {
    Datetime
} from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueDragResize from 'vue-drag-resize'
// Vuex Store
import store from './store/store'
import VueCircleSlider from 'vue-circle-slider'
//Vue .csv
import JsonCSV from 'vue-json-csv'

// Session
import VueSessionStorage from 'vue-sessionstorage'

import VueOtp2 from 'vue-otp-2';
import OtpInput from "@bachdgvn/vue-otp-input";
// Theme Configurations
import Autocomplete from 'v-autocomplete'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-autocomplete/dist/v-autocomplete.css'
import 'prismjs'
import 'prismjs/themes/prism.css'
import VsPrism from './components/prism/VsPrism.vue';
import fullscreen from 'vue-fullscreen'
import ToggleSwitch from 'vuejs-toggle-switch'
// Vue axios
import VueSuggestion from 'vue-suggestion'
import VueZoomer from 'vue-zoomer'
import {
    VueFormBuilderPlugin
} from 'v-form-builder'
import 'v-form-builder/dist/v-form-builder.css' //load CSS from your App
import VCalendar from 'v-calendar';
import VueSignaturePad from 'vue-signature-pad';

import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import './css/VueDraggableResizable.css'
import VueHtmlToPaper from 'vue-html-to-paper';
// Vue Router
import router from './router'
import '@/assets/scss/style.scss'
Vue.use(VTooltip)
    // Install BootstrapVue
Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
    // Loading the plugin into the Vue.
Vue.use(VueCollapse)
Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime);

Vue.component('vue-drag-resize', VueDragResize)

Vue.use(VueCircleSlider)
Vue.component('downloadCsv', JsonCSV)

Vue.component("v-otp-input", OtpInput);
Vue.use(VueOtp2)

Vue.use(Autocomplete)
Vue.component(VsPrism.name, VsPrism);
Vue.use(fullscreen)
Vue.use(ToggleSwitch)

Vue.use(VueSuggestion)
Vue.prototype.$http = axios
Vue.prototype.$url = "https://swdapi.ddns.net:8090/"
    // Vue.prototype.$url = "http://18.140.161.60:8090/"
Vue.prototype.$url2 = "https://swdapi.ddns.net:8092/"
    // Vue.prototype.$url = "http://localhost:8090/"
Vue.config.silent = true

// momentjs
Vue.prototype.$moment = moment

Vue.use(VueZoomer)
    // Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
        componentPrefix: 'vc'
    }) // Use <vc-calendar /> instead of <v-calendar />

// install now
Vue.use(VueFormBuilderPlugin)

// Signature Pad

Vue.use(VueSignaturePad)

Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(Vuesax, {
    theme: {
        colors: {
            primary: '#32c040',
            secondary: '#4e4e4e',
            warning: '#ff911e',
            third: '#00661b'
        }
    }
})
const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
        'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
}

Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
Vue.use(Embed);

// window.BeforeUnloadEvent(() => {
//     Vue.prototype.$http.post(Vue.prototype.$url+'logout', {
//         username: Vue.prototype.$session.get('username')
//     })
// })
// Vue Session
Vue.use(VueSessionStorage)

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')